// @ts-expect-error no types
import { makeSafeInnerHTML } from 'feedback-utils/sanitize';
import Selectors from 'feedback-public-submission-ui/constants/Selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const SurveyFooter = ({
  strings
}) => {
  const footerText = makeSafeInnerHTML(strings.commonStrings.thisSurveyIsWeb);
  return /*#__PURE__*/_jsx("div", {
    className: "footer",
    "data-selenium-test": Selectors.FOOTER,
    children: /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: footerText
    })
  });
};
export default SurveyFooter;